import React from "react";
import { Card, Button } from "react-bootstrap";
import { FaPencilAlt } from "react-icons/fa";

const AccountSecurityCard = ({ onPasswordChangeClick }) => {
  return (
    <Card className="shadow-sm mb-4">
      <Card.Header className="bg-light py-3">
        <Card.Title as="h5" className="mb-0">
          Account Security
        </Card.Title>
      </Card.Header>
      <Card.Body className="d-flex justify-content-between align-items-center">
        <span className="fw-bold">Password</span>
        <Button
          variant="outline-warning"
          size="sm"
          onClick={onPasswordChangeClick}
        >
          <FaPencilAlt className="me-1" /> Change
        </Button>
      </Card.Body>
    </Card>
  );
};

export default AccountSecurityCard;
